import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const insightStyles: moduleStyleType = {
    container: () => ({
        width: '100%',
    }),
    insightContainer: {
        width: '100%',
        padding: 4,
        border: `1px solid ${palette.border.subtle}`,
        marginTop: 5,
        borderRadius: '6px',
    },
    insightItem: {
        padding: 1,
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        ml: 0,
        mr: 2,
        fontSize: 'medium',
    },
    iconPositive: {
        color: 'success.main',
    },
    iconNegative: {
        color: 'warning.main',
    },
    iconAlert: {
        color: 'icons.vermillion',
    },
    iconNeutral: {
        color: 'primary.main',
    },
}

export const InsightRecommendationStyles: moduleStyleType = {
    container: {
        border: '1px solid',
        borderColor: 'border.primary',
        borderRadius: 1,
        backgroundColor: 'background.default',
        padding: 2,
        mt: 3,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    denyContainer: {
        borderColor: 'error.main',
    },
    reviewContainer: {
        borderColor: 'warning.main',
    },
    recommendations: {
        ml: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    list: {
        pl: 4,
        listStyle: 'disc',
    },
    listItem: {
        display: 'list-item',
        pl: 1,
        pb: 0,
    },
    icon: {
        color: 'text.primary',
        fontSize: 24,
        margin: 0,
    },
    denyIcon: {
        color: 'error.main',
    },
    reviewIcon: {
        color: 'warning.main',
    },
}
